<template>
  <div>
    <Dropdown @on-click="print">
      <Button type="primary" :disabled="!ids.length">
        {{ $i18n.messages[en ? "en-US" : $i18n.locale]["print"] }}
        <Icon type="ios-arrow-down"></Icon>
      </Button>
      <template #list>
        <DropdownMenu v-if="ids.length">
          <DropdownItem
            :name="item.name"
            v-for="item in list"
            :key="item.name"
            >{{ item.name }}</DropdownItem
          >
        </DropdownMenu>
      </template>
    </Dropdown>
    <Modal v-model="modal" :title="$tz('打印')" :width="700" footer-hide>
      <Table border :columns="columns" :data="data"></Table>
    </Modal>
  </div>
</template>

<script>
import { postSheet, postPdf } from "@/api/order/list";
export default {
  name: "PrintLabel",
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    en: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("this.$i18n :>> ", this.$i18n);
  },
  data() {
    return {
      i18n: this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale],
      list: [
        {
          name:
            this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
              "sheet"
            ] + "(100*100)",
          miniLabel: true,
        },
        {
          name: this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
            "LabelMiniNoInvoice"
          ],
          miniLabel: true,
          ignoreInvoice: true,
        },
        {
          name:
            this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
              "sheet"
            ] + "(100*150)",
          specialLable: true,
          miniLabel: false,
        },
        {
          name:
            this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
              "sheet"
            ] + "(100*200)",
          miniLabel: false,
        },
        {
          name: this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
            "invoice"
          ],
          Invoice: true,
        },
      ],
      modal: false,
      columns: [
        {
          title:
            this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
              "label_url"
            ],
          key: "link",
          align: "center",
        },
        {
          align: "center",
          title:
            this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
              "operation"
            ],
          width: 100,
          key: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small",
                  },
                  on: {
                    click() {
                      window.open(params.row.link, "_blank");
                    },
                  },
                },
                this.$i18n.messages[this.en ? "en-US" : this.$i18n.locale][
                  "print"
                ]
              ),
            ]);
          },
        },
      ],
      data: [],
    };
  },
  methods: {
    t(name) {
      return this.i18n[name];
    },
    print(item) {
      item = this.list.find((t) => t.name == item);
      let ids = this.ids.map((t) => t.airway_number);
      if (item.Invoice) {
        postPdf({
          type: item.Invoice,
          merge: true,
          rule: "standard",
          orderNo: ids,
        }).then((res) => {
          if (res.data.status) {
            window.open(this.$globalUrl + res.data.data[0].url, "_blank");
          } else {
            this.$Message.error(res.data.message);
          }
        });
        return;
      }
      this.$Notice.info({
        title: this.t("printing"),
        name: "print",
        desc: this.t("printingTip"),
      });
      postSheet({
        miniLabel: item.miniLabel,
        specialLable: item.specialLable,
        ignoreInvoice: item.ignoreInvoice || false,
        single: true,
        orders: ids,
      }).then((res) => {
        console.log(res);
        if (res.data.status) {
          this.$Notice.close("print");
          if (res.data.payload.length === 1) {
            window.open(res.data.payload[0].link, "_blank");
          } else {
            this.data = res.data.payload;
            this.modal = true;
          }
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style>
</style>